"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../../constants/colors");
var classnames_1 = __importDefault(require("classnames"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  z-index: 2;\n"], ["\n  display: inline-block;\n  position: relative;\n  z-index: 2;\n"])));
var PopupContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  position: relative;\n"], ["\n  display: block;\n  position: relative;\n"])));
var Trigger = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var Popup = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: #ffffff;\n  border-radius: 2px;\n  border: 1px solid ", ";\n  display: block;\n  font-size: 14px;\n  height: 100px;\n  line-height: 20px;\n  padding: 10px;\n  position: absolute;\n  right: -320px;\n  text-align: left;\n  top: -58px;\n  width: 300px;\n\n  &:before {\n    background-color: #ffffff;\n    bottom: auto;\n    box-shadow: -1px 1px 0 0 ", ";\n    content: '';\n    display: block;\n    height: 10px;\n    left: -5px;\n    line-height: 20px;\n    margin-top: -5px;\n    position: absolute;\n    right: auto;\n    top: 50%;\n    transform: rotate(45deg);\n    width: 10px;\n    z-index: 2;\n  }\n"], ["\n  background-color: #ffffff;\n  border-radius: 2px;\n  border: 1px solid ", ";\n  display: block;\n  font-size: 14px;\n  height: 100px;\n  line-height: 20px;\n  padding: 10px;\n  position: absolute;\n  right: -320px;\n  text-align: left;\n  top: -58px;\n  width: 300px;\n\n  &:before {\n    background-color: #ffffff;\n    bottom: auto;\n    box-shadow: -1px 1px 0 0 ", ";\n    content: '';\n    display: block;\n    height: 10px;\n    left: -5px;\n    line-height: 20px;\n    margin-top: -5px;\n    position: absolute;\n    right: auto;\n    top: 50%;\n    transform: rotate(45deg);\n    width: 10px;\n    z-index: 2;\n  }\n"])), colors_1.colors.BLUE_MEDIUM_300, colors_1.colors.BLUE_MEDIUM_300);
var AXSPopup = function (_a) {
    var trigger = _a.trigger, content = _a.content, props = __rest(_a, ["trigger", "content"]);
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    return (React.createElement(Container, __assign({}, props, { className: classnames_1.default(['c-axs-popup', props.className]) }),
        React.createElement(Trigger, { onMouseOver: function () { return setOpen(true); }, onMouseOut: function () { return setOpen(false); } }, trigger),
        open ? React.createElement(PopupContainer, null,
            React.createElement(Popup, null, content)) : null));
};
exports.default = AXSPopup;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map